<div class="modal-customized">
  <div class="modal-title">
    <h3>
      <i class="fa-solid fa-pencil icon-title"></i>
      {{ editAllow ? 'CREATE STATUS' : 'EDIT INFOS' }}
    </h3>
    <span class="fa fa-times modal-close" (click)="closeDialog()"></span>
  </div>

  <div class="modal-content">
    <div class="controls">
      <div class="to-left">
        <span class="title">
          Request name:
          <strong>{{ data.requestType }}</strong>
        </span>
      </div>
      <div class="to-right">
        <span class="required-fields"> <em>*</em>Required fields </span>
      </div>
    </div>

    <app-loader class="adjust-loader" *ngIf="showLoader; else showContent"></app-loader>

    <ng-template #showContent>
      <!-- Form Content -->
      <section class="status-form">
        <div class="form-content">
          <ng-container *ngFor="let parent of formContent; let first = first; let last = last; let index = index">
            <div class="form-tree">
              <!-- Parent -->
              <div class="form-row">
                <div class="inputs-control">
                  <mat-form-field
                    appearance="outline"
                    [style.width]="first ? '450px' : last ? '285px' : '285px'"
                    [ngClass]="{
                      'mat-form-field-invalid': isFieldEmpty(parent.statusName),
                      'input-disabled': first || editAllow
                    }"
                  >
                    <mat-label>Status Name</mat-label>
                    <input
                      (input)="hasChanged = true"
                      (blur)="addOption(statusName.value, index, false, $event)"
                      matInput
                      #statusName
                      maxlength="100"
                      type="text"
                      placeholder="Enter status name here.."
                      [(ngModel)]="parent.statusName"
                      [value]="parent.statusName"
                    />
                    <mat-hint class="count" align="end">{{ statusName.value.length }} / 100</mat-hint>
                  </mat-form-field>

                  <!-- Action Name -->
                  <mat-form-field
                    appearance="outline"
                    [style.width]="first ? '450px' : last ? '285px' : '285px'"
                    [ngClass]="{ 'input-disabled': first || editAllow }"
                  >
                    <mat-label>Action Name</mat-label>
                    <input
                      (input)="hasChanged = true"
                      matInput
                      #actionName
                      maxlength="100"
                      type="text"
                      placeholder="Enter action name here.."
                      [(ngModel)]="parent.actionName"
                    />
                    <mat-hint class="count" align="end">{{ actionName.value.length }} / 100</mat-hint>
                  </mat-form-field>

                  <!-- Comments -->
                  <mat-form-field
                    appearance="outline"
                    [style.width]="first ? '430px' : last ? '285px' : '285px'"
                    [ngClass]="{ 'input-disabled': first || editAllow }"
                    *ngIf="!first"
                  >
                    <mat-label>Comments</mat-label>
                    <input
                      (input)="hasChanged = true"
                      matInput
                      #comments
                      maxlength="100"
                      type="text"
                      placeholder="Enter comments here.."
                      [(ngModel)]="parent.comments"
                    />
                    <mat-hint class="count" align="end">{{ comments.value.length }} / 300</mat-hint>
                  </mat-form-field>

                  <!-- Area Responsible -->
                  <mat-form-field
                    appearance="outline"
                    [style.width]="first || last ? '200px' : '200px'"
                    [ngClass]="{ 'input-disabled': first || editAllow || parent.requestorAreaFlag }"
                  >
                    <mat-label>Area Responsible</mat-label>
                    <mat-select
                      (selectionChange)="hasChanged = true"
                      (selectionChange)="onSelectionChangeArea($event, parent)"
                      [value]="parent.teamRespId"
                    >
                      <mat-option [value]="undefined">{{ removeOptionName.replaceAll('_', ' ') }}</mat-option>
                      <mat-option *ngFor="let select of selectTeams" [value]="select.teamId">{{
                        select.teamRespName?.replaceAll('_', ' ') || ''
                      }}</mat-option>
                    </mat-select>
                  </mat-form-field>

                  <!-- Prev Status -->
                  <mat-form-field
                    appearance="outline"
                    *ngIf="!first"
                    style="width: 200px"
                    [ngClass]="{
                      'mat-form-field-invalid': isFieldEmpty(parent.previousStatusName),
                      'input-disabled': first || editAllow
                    }"
                  >
                    <mat-label>Previous Status</mat-label>
                    <mat-select
                      (selectionChange)="hasChanged = true"
                      [(ngModel)]="parent.previousStatusId"
                      (selectionChange)="onSelectionChange($event, true, parent)"
                    >
                      <mat-option [value]="undefined">{{ removeOptionName }}</mat-option>
                      <mat-option *ngFor="let select of selectChoices" [value]="select.statusId">{{
                        select.statusName
                      }}</mat-option>
                    </mat-select>
                  </mat-form-field>

                  <!-- Next Status -->
                  <mat-form-field
                    appearance="outline"
                    style="width: 200px"
                    [ngClass]="{
                      'invalid-feedback': isFieldEmpty(parent.nextStatusName),
                      'input-disabled': editAllow || parent.multipleSelecFlag || parent.processEndFlag
                    }"
                  >
                    <mat-label>Next Status</mat-label>
                    <mat-select
                      (selectionChange)="hasChanged = true"
                      [(ngModel)]="parent.nextStatusId"
                      (selectionChange)="onSelectionChange($event, false, parent)"
                    >
                      <mat-option [value]="undefined">{{ removeOptionName }}</mat-option>
                      <mat-option *ngFor="let select of selectChoices" [value]="select.statusId">{{
                        select.statusName
                      }}</mat-option>
                    </mat-select>
                  </mat-form-field>

                  <!-- Requestor Area -->
                  <button
                    aria-label="Requestor Area"
                    class="btn-icon"
                    [ngClass]="{
                      'btn-icon-disabled': first || parent.teamRespName,
                      'btn-icon-active': parent.requestorAreaFlag,
                      'input-disabled': editAllow || parent.teamRespName
                    }"
                    [disabled]="first || editAllow || parent.teamRespName"
                    matTooltipPosition="above"
                    matTooltipClass="custom-mat-tooltip"
                    matTooltip="Requestor Area?"
                    (click)="selectRequestArea(parent); parent.requestorAreaFlag = !parent.requestorAreaFlag"
                  >
                    <i class="icon-requestor"></i>
                  </button>

                  <!-- Process End -->
                  <button
                    aria-label="Process END"
                    class="btn-icon"
                    [ngClass]="{
                      'btn-icon-disabled': first,
                      'btn-icon-active': parent.processEndFlag,
                      'input-disabled': editAllow
                    }"
                    [disabled]="first || editAllow"
                    matTooltipPosition="above"
                    matTooltipClass="custom-mat-tooltip"
                    matTooltip="Process END?"
                    (click)="parent.processEndFlag = !parent.processEndFlag; selectProcessEnd(parent)"
                  >
                    <i class="icon-process"></i>
                  </button>

                  <!-- Multiple Selection -->
                  <button
                    aria-label="Multiple Selection"
                    class="btn-icon"
                    [ngClass]="{
                      'btn-icon-disabled': first,
                      'btn-icon-active': parent.multipleSelecFlag,
                      'input-disabled': editAllow
                    }"
                    [disabled]="first || editAllow"
                    matTooltipPosition="above"
                    matTooltipClass="custom-mat-tooltip"
                    matTooltip="Multiple Selection?"
                    (click)="parent.multipleSelecFlag = !parent.multipleSelecFlag; selectMulti(parent)"
                  >
                    <i class="icon-multiple"></i>
                  </button>

                  <!-- Require Justification -->
                  <button
                    aria-label="Require Justification"
                    class="btn-icon"
                    [ngClass]="{
                      'btn-icon-disabled': first,
                      'btn-icon-active': parent.justificationFlag,
                      'input-disabled': editAllow
                    }"
                    [disabled]="first || editAllow"
                    matTooltipPosition="above"
                    matTooltipClass="custom-mat-tooltip"
                    matTooltip="Require Justification?"
                    (click)="parent.justificationFlag = !parent.justificationFlag"
                  >
                    <i class="icon-justification"></i>
                  </button>
                </div>

                <div class="buttons-control">
                  <button
                    class="btn-remove"
                    [ngClass]="{
                      'invalid-feedback': getStep1['statusName'].invalid,
                      'input-disabled': first || editAllow
                    }"
                    [disabled]="first || editAllow"
                    (click)="removeLine('', index, false, $event)"
                  >
                    <i class="fa-solid fa-circle-minus"></i>
                  </button>
                  <button
                    [disabled]="editAllow"
                    [ngClass]="{ 'input-disabled': editAllow }"
                    class="btn-add-parent-icon"
                    (click)="addParent(index)"
                  >
                    <i class="fa-solid fa-circle-plus"></i>
                  </button>
                </div>
              </div>
            </div>
          </ng-container>

          <!-- Actions Form -->
          <div class="actions-form">
            <button
              mat-flat-button
              class="btn-add-parent"
              [disabled]="editAllow"
              (click)="addParent(this.formContent.length)"
            >
              <i class="fa-solid fa-circle-plus"></i> Add Connection
            </button>
          </div>
        </div>

        <!-- Actions Modal -->
        <div class="controls-foot">
          <!-- Infos -->
          <!-- <div class="creation-infos">
            <div class="to-left">
              <span class="info-block">
                <i class="fa-solid fa-calendar-days"></i> Creation Date: <b>{{ this.data.createdDate || "-" }}</b>
              </span>
            </div>
            <div class="to-right">
              <span class="info-block">
                <i class="fa-solid fa-user"></i> Created By: <b>{{ this.data.createdBy || "-" }}</b>
              </span>
            </div>
          </div> -->

          <!-- Actions -->
          <div class="creation-actions">
            <div class="to-left">
              <button mat-stroked-button class="btn-cancel" (click)="closeDialog()" *ngIf="!editAllow">Cancel</button>

              <button *ngIf="editAllow" mat-stroked-button class="btn-outline" (click)="editAllow = false">
                <span class="btn-edit-info"><i class="fa-solid fa-pencil"></i>EDIT INFOS</span>
              </button>
            </div>
            <button
              *ngIf="!editAllow"
              [disabled]="btnSave"
              mat-flat-button
              class="btn-save"
              [disabled]="editAllow"
              (click)="save()"
            >
              Save
            </button>

            <button *ngIf="editAllow" mat-flat-button class="btn-save" (click)="closeDialog()">Ok</button>
          </div>
        </div>
      </section>
    </ng-template>
  </div>
</div>
